import React from 'react';
import { Container, Content, Main } from './styles';
import Navigation from '~/components/Navigation';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';
import { useLayout } from './LayoutContext';
// import Navbars from '../NavbarOld';

interface TypeTeste {
  url?: string;
}

const LayoutContent: React.FC<TypeTeste> = ({ url }) => {
  const { collapsed, setCollapsed } = useLayout();

  return (
    <Container>
      <Sidebar />
      <Main collapsed={collapsed}>
        <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
        {/* <Navbars /> */}
        <Content>
          <Navigation url={url} />
        </Content>
      </Main>
    </Container>
  );
};

export default LayoutContent;
